import Vue from "vue";
import Router from "vue-router";
const routerPush = Router.prototype.push;

Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error);
};

Vue.use(Router);
export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("../views/index.vue")
    },
    {
      path: "/ProductList",
      name: "ProductList",
      component: () => import("../views/ProductList.vue")
    },
    
    {
      path: "/WineCulture",
      name: "WineCulture",
      component: () => import("../views/WineCulture.vue")
    },
    {
      path: "/datails",
      name: "Details",
      component: () => import("../views/Details.vue")
    },
    {
      path: "/PersonalCenter",
      name: "PersonalCenter",
      component: () => import("../views/personalCenter.vue")
    },
    
    // {
    //   path: "/WineryDetails",
    //   name: "WineryDetails",
    //   component: () => import("../views/WineryDetails.vue")
    // },
    
    {
      path: "/Login",
      name: "Login",
      component: () => import("../views/login.vue")
    },
    {
      path: "/Search",
      name: "Search",
      component: () => import("../views/Search.vue")
    },
    {
      path: "/Announcement",
      name: "announcement",
      component: () => import("../views/Announcement.vue")
    },
    {
      path:'/DownLoad',
      name:'download',
      component:() => import("../views/DownLoad.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js